var $921082c7b3a14076$exports = {};
$921082c7b3a14076$exports = {
    "valid": `V\xe1lido`
};


export {$921082c7b3a14076$exports as default};
//# sourceMappingURL=es-ES.mjs.map
